import React, { useState, useEffect } from "react";
import { fetchFacilities } from "../utils/facilitiesApi";
import { motion } from "framer-motion";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5 },
  },
};

const titleVariants = {
  hidden: { opacity: 0, y: -20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6 },
  },
};

export default function Facilities() {
  const [facilities, setFacilities] = useState([]);

  useEffect(() => {
    fetchFacilities().then((data) => {
      setFacilities(data || []);
    });
  }, []);

  return (
    <div className="container-fluid pt-5 overflow-hidden">
      <div className="container pb-3">
        <motion.div
           initial="hidden"
           whileInView="visible"
           viewport={{ once: true, amount: 0.2 }}
           variants={titleVariants}
        >
          <p className="section-title pr-5">
            <span className="pr-2">Why us</span>
          </p>
          <h1 className="mb-4">Facilities For Your Kid</h1>
        </motion.div>
        
        <motion.div 
          className="row"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          {facilities && facilities.length > 0 ? (
            facilities.map((el, idx) => (
              <motion.div 
                className="col-lg-4 col-md-6 pb-1 mb-3" 
                key={el.id || idx}
                variants={itemVariants}
              >
                <div
                  className="d-flex bg-light shadow-sm rounded mb-4 hover-zoom"
                  style={{ height: "100%", alignItems: "center", minHeight: 120 }}
                >
                  <div className="pl-3">
                    <i className="flaticon-050-fence h1 font-weight-normal text-primary" />
                  </div>
                  <div className="pl-4 pr-4">
                    <h5>{el.title}</h5>
                    <p className="m-0 text-muted">{el.desc}</p>
                  </div>
                </div>
              </motion.div>
            ))
          ) : (
            <div className="col-12 text-center text-muted py-5">
              {/* Optional: Loading or No Facilities message */}
            </div>
          )}
        </motion.div>
      </div>
    </div>
  );
}
